import { SxProps, Theme } from "@mui/material";

export const root: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
});

export const rowContainer: SxProps<Theme> = (theme) => ({
  display: "flex",
  gap: theme.spacing(3),
});

export const datePicker: SxProps<Theme> = (theme) => ({
  flex: 1,
});
